// eslint-disable-next-line no-restricted-imports -- the one place that wraps it
import { cva as cvaUnmerged } from 'class-variance-authority';
import { cn } from './cn';

// eslint-disable-next-line no-restricted-imports -- types only, re-exported for the same import site
export type { VariantProps } from 'class-variance-authority';

/**
 * `class-variance-authority`'s `cva`, with its output run through `cn()`. Raw cva output keeps a
 * base class next to the variant class that overrides it (`max-w-x` + `max-w-none`), and stylesheet
 * order — not the variant — picks the winner, so the same call rendered one way inside `cn()` and
 * another way outside it. Merged here, a variant always wins wherever the result lands.
 */
export const cva: typeof cvaUnmerged = (base, config) => {
  const variants = cvaUnmerged(base, config);
  return (props) => cn(variants(props));
};
